const axios = require('axios')
const dayjs = require('dayjs')
const md5 = require('js-md5')
import store from '@/store'
import { Message } from 'element-ui'

let lock = false
class Api {
  static BASE_URL = 'https://flomoapp.com/api/v1'
  // static BASE_URL = 'http://localhost:8001/api/v1'

  static call(method, url, params, callback) {
    const KEY = 'flomo_web'
    const APP_VERSION = '2.0'
    let full_url = ''
    if (url.indexOf('http') === -1) {
      full_url = this.BASE_URL + url
    } else {
      full_url = url
    }
    let timestamp = dayjs().unix()
    let all_params = { ...params }
    if (url === '/user/me') {
      all_params = {}
    }

    all_params.timestamp = timestamp
    all_params.api_key = KEY
    all_params.app_version = APP_VERSION
    all_params.platform = 'web'
    if (process.env.IS_ELECTRON) {
      all_params.app_version = this.getPackageVersion()
      all_params.platform = this.getPlatform()
    }

    if (this.isSupportWebp()) {
      all_params.webp = '1'
    }
    // 深拷贝all_params, 不要直接修改params，getSign会修改files顺序
    let params_copy = JSON.parse(JSON.stringify(all_params))
    let sign = this._getSign(params_copy)
    all_params.sign = sign

    let access_token = ''
    if (localStorage.getItem('me')) {
      access_token = JSON.parse(localStorage.getItem('me')).access_token
    }

    axios
      .request({
        method: method,
        url: full_url,
        params: !['POST', 'PUT', 'PATCH'].includes(method) ? all_params : null,
        data: ['POST', 'PUT', 'PATCH'].includes(method) ? all_params : null,
        headers: {
          // Authorization: 'Bearer ' + store.state.me.access_token, tray 取值有问题，改为下面的方式
          Authorization: 'Bearer ' + access_token, //登录时 localStorage.getItem('me') 值为null
        },
        timeout: 60000,
      })
      .then((response) => {
        // 获取响应头
        const contentType = response.headers['content-type']

        // 判断响应是不是 html
        if (contentType.indexOf('html') > -1) {
          Message.error('当前网络不通，请检查网络连接情况')
          return
        }
        if (response.data.code !== 0) {
          if (response.data && response.data.code === -10) {
            store.commit('removeMe')
            location.reload()
          } else if (response.data && response.data.code === -20) {
            // -20服务端冲突
            // 不处理 也不进行错误提示 它应当会在下次同步时,转化为客户端冲突
            // 也可能系统时间错误导致,3次失败后自动强制修改本地updated_at并强制覆盖
          } else {
            console.info('request api fail', url, response.data)
            if (
              full_url.indexOf('check_password') === -1 &&
              full_url.indexOf('login_by_oa_qrcode') === -1 &&
              full_url.indexOf('notify_memo_progress') === -1
            ) {
              Message.error(response.data.message)
            }
          }
        } else {
          if (process.env.IS_ELECTRON) {
            console.log(url, response.data)
          }
        }
        callback(response)
      })
      .catch((error) => {
        // 重连时不进行错误提示
        if (params && typeof params === 'object' && params.reConnect) {
          return
        }
        console.log('request api error', url, error)
        // 判断请求异常信息中是否含有超时timeout字符串
        this.handleError(error, callback)
      })
  }

  static displayErrorMessage(errorMessage) {
    if (!lock) {
      lock = true
      Message.error(errorMessage)

      setTimeout(() => {
        lock = false
      }, 3000)
    }
  }

  static handleError(error, callback) {
    const language = window.navigator.userLanguage || window.navigator.language
    const shortLanguage = language.slice(0, 2)

    if (error.message.includes('timeout')) {
      const errorMessage = shortLanguage === 'zh' ? '网络超时' : 'Network timeout'
      this.displayErrorMessage(errorMessage)
    } else {
      const errorMessage =
        shortLanguage === 'zh' ? '网络异常，请检查网络后再试' : 'Network error, please check your network and try again'
      this.displayErrorMessage(errorMessage)
    }

    if (callback) {
      callback({
        data: {
          code: -1,
          message: error.message,
        },
      })
    }
  }

  static _getSign(params) {
    const SECRET = 'dbbc3dd73364b4084c3a69346e0ce2b2'

    params = this._ksort(params)
    let paramString = ''
    for (let key in params) {
      let value = params[key]
      //  !value 排除 value == 0 的情况
      if (typeof value === 'undefined' || (!value && value !== 0)) continue
      // paramString += key + '=' + value + '&'
      if (Array.isArray(value)) {
        value.sort(function (a, b) {
          return a && b ? a.toString().localeCompare(b.toString()) : 0
        })

        for (let index in value) {
          let v = value[index]
          paramString += key + '[]=' + v + '&'
        }
      } else {
        paramString += key + '=' + value + '&'
      }
    }
    paramString = paramString.substring(0, paramString.length - 1)
    // return paramString;
    let sign = md5(paramString + SECRET)
    // console.log(paramString);
    // console.log(paramString + SECRET);
    // console.log(sign);
    return sign
  }

  static _ksort(obj) {
    var keys = Object.keys(obj).sort(),
      sortedObj = {}
    for (var i in keys) {
      sortedObj[keys[i]] = obj[keys[i]]
    }
    return sortedObj
  }

  // 判断是否支持webp
  static isSupportWebp() {
    return document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') == 0
  }

  // 获取当前platform
  static getPlatform() {
    var u = navigator.userAgent
    var isMac = u.indexOf('Mac OS X') > -1 //mac终端
    var isWindows = u.indexOf('Windows NT') > -1 //windows终端

    if (isMac) {
      return 'mac'
    }
    if (isWindows) {
      return 'windows'
    }

    return 'web'
  }

  static getPackageVersion() {
    return require('../../package.json').version
  }

  // 请求其他域名
  static callOtherDomain(method, url, params, callback) {
    const APP_VERSION = '2.0'
    let all_params = { ...params }
    all_params.app_version = APP_VERSION
    all_params.platform = 'web'
    if (process.env.IS_ELECTRON) {
      all_params.app_version = this.getPackageVersion()
      all_params.platform = this.getPlatform()
    }
    axios
      .request({
        method: method,
        url: url,
        params: !['POST', 'PUT', 'PATCH'].includes(method) ? all_params : null,
        data: ['POST', 'PUT', 'PATCH'].includes(method) ? all_params : null,
        headers: {
          'Content-Type': 'application/json',
        },
        timeout: 60000,
      })
      .then((response) => {
        callback(response)
      })
      .catch((error) => {
        console.log(error)
        // 判断请求异常信息中是否含有超时timeout字符串
        const language = window.navigator.userLanguage || window.navigator.language
        const shortLanguage = language.slice(0, 2)
        if (error.message.includes('timeout')) {
          const errorMessage = shortLanguage == 'zh' ? '网络超时' : 'Network timeout'
          Message.error(errorMessage)
        }
        // return Promise.reject(error)
        //无网 / DNS错误 等非http错误回调
        if (callback) callback(error)

        const errorMessage =
          shortLanguage == 'zh'
            ? '网络异常，请检查网络后再试'
            : 'Network error, please check your network and try again'
        Message.error(errorMessage)
      })
  }

  // promise
  static callPromise(method, url, params) {
    const KEY = 'flomo_web'
    const APP_VERSION = '2.0'
    let full_url = ''
    if (url.indexOf('http') === -1) {
      full_url = this.BASE_URL + url
    } else {
      full_url = url
    }
    let timestamp = dayjs().unix()

    let all_params = { ...params }

    all_params.timestamp = timestamp
    all_params.api_key = KEY
    all_params.app_version = APP_VERSION
    all_params.platform = 'web'
    if (process.env.IS_ELECTRON) {
      all_params.app_version = this.getPackageVersion()
      all_params.platform = this.getPlatform()
    }

    if (this.isSupportWebp()) {
      all_params.webp = '1'
    }
    // 深拷贝all_params, 不要直接修改params，getSign会修改files顺序
    let params_copy = JSON.parse(JSON.stringify(all_params))
    let sign = this._getSign(params_copy)
    all_params.sign = sign

    let access_token = ''
    if (localStorage.getItem('me')) {
      access_token = JSON.parse(localStorage.getItem('me')).access_token
    }

    return axios.request({
      method: method,
      url: full_url,
      params: !['POST', 'PUT', 'PATCH'].includes(method) ? all_params : null,
      data: ['POST', 'PUT', 'PATCH'].includes(method) ? all_params : null,
      headers: {
        // Authorization: 'Bearer ' + store.state.me.access_token, tray 取值有问题，改为下面的方式
        Authorization: 'Bearer ' + access_token, //登录时 localStorage.getItem('me') 值为null
      },
      timeout: 60000,
    })
  }
}

export default Api
